export class Scope {
    static jsonMap = {
        idOrganisme: { key: 'idOrganisme', optional: true },
        idDomaine: { key: 'idDomaine', optional: true }
    };

    idOrganisme: number = undefined;
    idDomaine: number = undefined;
}
